module.exports = "<h3>\n    <i class=\"fas fa-building\"></i>\n    Home\n</h3>\n<hr class=\"mt-0\"/>\n<div class=\"container-fluid\">\n    Welcome to Chat-O-Matic. The tool for automatic messaging.\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 596
// module chunks = 1